/**
 * Strategic Management - Buried Point Helper Functions
 * 埋点辅助函数
 * 
 * Following the pattern from Opinion project
 */

import { buriedPoint as baseBuriedPoint, buriedBtnPoint as baseBuriedBtnPoint } from '@home/utils/buriedPoint';

const typeId = 'mgmt_pc_v2';

/**
 * Page buried point for Strategic Management
 * 页面埋点
 */
export const SGBuriedPoint = (param?: any) => {
  baseBuriedPoint({ typeId, ...param });
};

/**
 * Button buried point for Strategic Management
 * 按钮埋点
 */
export const SGBuriedBtnPoint = (param?: any) => {
  baseBuriedBtnPoint({ typeId, ...param });
};

/**
 * Helper to create buried point from page config
 * 从页面配置创建埋点
 */
export const createPagePoint = (pageConfig: any) => {
  const { pageName, pageId, pagePath, common } = pageConfig;
  return {
    pageName,
    pageId,
    pagePath,
    ...common,
  };
};

/**
 * Helper to create button point from page config
 * 从页面配置创建按钮埋点
 */
export const createBtnPoint = (pageConfig: any, buttonKey: string, extInfo?: string) => {
  const { pageId, common, button } = pageConfig;
  const btnConfig = button?.[buttonKey];
  
  if (!btnConfig) {
    console.warn(`[BuriedPoint] Button key "${buttonKey}" not found in config`);
    return null;
  }
  
  return {
    pageId,
    buttonId: btnConfig.buttonId,
    buttonName: btnConfig.buttonName,
    extInfo: extInfo || btnConfig.buttonName,
    ...common,
  };
};

